















































































































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import CustomerPickerComponent from '@/shared/customer-picker/customer-picker.component.vue';
import ContractNotBilledFilter from '@/domain/contract/entity/contract-not-billed-filter.entity'
import Pagination from '@/domain/pagination.entity';
import ResultCenter from '@/domain/business-unit/entity/result-center.entity';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';
import SearchCustomerComponent from '@/shared/search/customer-search.component.vue';
import Customer from '@/domain/customer/entity/customer.entity';
import CustomerService from '@/domain/customer/service/customer.service';
import DateFormat from '@/shared/utils/date-format';
import MainButton from '@/shared/buttons/main-button.component.vue';
import VueToExcel from 'vue-json-excel';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ContractNotBilledService from '@/domain/contract/service/contract-not-billed.service';
import ContractNotBilled from '@/domain/contract/entity/contract-not-billed.entity';
import toDocument from '@/shared/directive/toDocument';
import { DOCUMENT_MASKS } from '@/shared/utils/cnpj';

@Component({
  components: {
    CustomerPickerComponent,
    SearchCustomerComponent,
    MainButton,
    VueToExcel,
  },
})
export default class ContractNotBilledFilterComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  @Prop({
    required: false,
    default: new ContractNotBilledFilter(),
  })
  private contracts!: ContractNotBilledFilter[];

  private filter: ContractNotBilledFilter = new ContractNotBilledFilter()

  private resultCenters: Array<ResultCenter> = [];

  private customers: Array<Customer> = [];

  private beneficiaries: Array<Customer> = [];

  private lastFilteredBeneficiary = '';

  private lastFilteredName: string = '';

  private customerFetch: string = '';

  private ref: any = this.$refs;

  private loadingXls: boolean = false;

  private pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    defaultSort: 'name|asc',
  })

  created() {
    this.getCustomers(this.customerFetch);
    this.getResultCenters();
    this.send();
  }

  @Watch('businessUnitId')
  getResultCenters(): void {
    BusinessUnitService.getResultCenters(this.businessUnitId)
      .then((response) => this.resultCenters = response);
  }

  send() {
    this.$emit('filter', this.filter);
  }

  getBeneficiaries(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredBeneficiary) {
      this.lastFilteredBeneficiary = name;
      CustomerService.getByTradingNameOrName(this.pagination, name,
        this.filter.selectedBeneficiaryOption, this.businessUnitId)
        .then((response: any) => {
          this.beneficiaries = Customer.ofList(response.content)
        });
    }
  }

  getCustomers(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredName) {
      this.lastFilteredName = name;
      CustomerService.getByTradingNameOrName(this.pagination, name,
        this.filter.selectedCustomerOption, this.businessUnitId)
        .then((response: any) => {
          this.customers = Customer.ofList(response.content)
        });
    }
  }

  updateFilterField(field: string, value: string) {
    this.filter[field] = value;
  }

  clear() {
    this.ref.form.reset();
    this.filter.clear();
  }

  get beneficiaryItemText() {
    return this.filter.isBeneficiaryTradingNameFetch
      ? 'tradingName' : 'name';
  }

  get customerItemText() {
    return this.filter.isTradingNameFetch
      ? 'tradingName' : 'name';
  }

  get mask() {
    return DOCUMENT_MASKS;
  }

  get competenceDateText() {
    return DateFormat.fullMonthAndYear(DateFormat.localDateToLocal(this.filter.competence));
  }

  csvLabel = {
    'Número do contrato': 'contractNumber',
    'Centro de resultado': 'resultCenter',
    Beneficiário: 'beneficiary',
    'ID Contrato': 'externalId',
    Cliente: 'customerName',
    'Nome Fantasia': 'customerTradingName',
    'Número Documento': 'customerDocument',
  }

  exportToXLS(): Promise<void | ContractNotBilled[]> {
    this.loadingXls = true;
    const pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
      page: 1,
    });
    return ContractNotBilledService.filter(pagination, this.businessUnitId, this.filter)
      .then(({ content } : any) => ContractNotBilled.ofList(content))
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingXls = false);
  }
}
